import React from 'react';
import classes from './Button.module.scss';

const Button = (props) => {
    let buttonElement = null;
    switch (props.buttontype) {
        case("submit"):
            buttonElement = <button style={{width: props.width + 'rem'}} className={classes.Button_element} {...props}>{props.label}</button>
            break;
        default:
            buttonElement = <button style={{width: props.width + 'rem'}} className={classes.Button_element} {...props}>{props.label}</button>
    }

    return (
        <div className={classes.Button}>
            {buttonElement}
        </div>
    );
}

export default Button;